import { render } from "./AttachmentPreviewComponent.vue?vue&type=template&id=53ef26dd&scoped=true"
import script from "./AttachmentPreviewComponent.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewComponent.vue?vue&type=script&lang=js"

import "./AttachmentPreviewComponent.vue?vue&type=style&index=0&id=53ef26dd&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ef26dd"]])

export default __exports__